<div class="list-page">
  <h2>Push-ilmoitukset asiakkaille</h2>

  <div style="max-width: 600px">
    <p>Lähetä push-ilmoitus asiakkaan kaikkien aktiivisten käyttäjien mobiililaitteisiin.</p>

    <mat-form-field style="width: 100%">
      <mat-label>Asiakas</mat-label>
      <input type="text" matInput [formField]="asiakasHaku" [matAutocomplete]="asiakasAuto" />
      <mat-autocomplete #asiakasAuto="matAutocomplete" [displayWith]="asiakasDisplay" (optionSelected)="valitseAsiakas($event.option.value)">
        @for (asiakas of suodatetutAsiakkaatObservable | async; track asiakas.k) {
          <mat-option [value]="asiakas">{{ asiakas.n }} ({{ asiakas.y }})</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <form>
      <mat-form-field style="width: 100%">
        <mat-label>Otsikko</mat-label>
        <input matInput [formField]="lomake.otsikko" />
        @if (onkoVirhe(lomake.otsikko, 'required') && lomake.otsikko().touched()) {
          <mat-error>Otsikko puuttuu.</mat-error>
        }
      </mat-form-field>

      <mat-form-field style="width: 100%">
        <mat-label>Viesti</mat-label>
        <textarea matInput [formField]="lomake.teksti" rows="4"></textarea>
        @if (onkoVirhe(lomake.teksti, 'required') && lomake.teksti().touched()) {
          <mat-error>Viesti puuttuu.</mat-error>
        }
      </mat-form-field>
    </form>

    @if (commonError()) {
      <div class="error-text">
        {{ commonError() }}
      </div>
    }

    <div style="display: flex; justify-content: flex-end; margin-top: 10px">
      <app-primary-button (click)="laheta()" actionId="Lähetä push-ilmoitus asiakkaalle" [disabled]="!valittuAsiakas()" matIcon="send"> Lähetä </app-primary-button>
    </div>
  </div>
</div>
